import styled from 'styled-components';

export const Container = styled.div`
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    width: 100%;
    max-width: 600px;
    margin: 24px auto 24px auto;
    background-color: ${(props) => props.theme.palette.secondaryA10};
    border-radius: 8px;
    padding: 40px;

    ${(props) => props.theme.breakpointTo.sm} {
        width: calc(100% - 64px);
        padding: 16px;
        margin: auto;
    }

    .camera-access {
        &-wrapper {
            margin: auto;
            max-width: 340px;
            text-align: center;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 8px;
        }
        &-title {
            margin-top: 8px;
            margin-bottom: 24px;
            margin-right: auto;
        }
        &-subtitle {
            margin-right: auto;
        }
        &-text {
            max-width: 420px;
            margin: 0;
        }

        &-actions {
            margin-top: 8px;
        }

        &-icon {
            width: 64px;
            height: 64px;
        }

        &-close-icon {
            position: absolute;
            right: 20px;
            top: 20px;

            ${(props) => props.theme.breakpointTo.md} {
                right: 50px;
                top: 40px;
            }
        }
        &-list {
            list-style: inherit;
            display: flex;
            flex-direction: column;
            align-self: flex-start;
            gap: 4px;
            text-align: left;
            padding-left: 1.5rem;
            margin-bottom: 24px;
        }
    }
`;
